import React from 'react';

type OpenProps = {
  width?: number;
  height?: number;
};

const Open = ({ width = 32, height = 32 }: OpenProps) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='12' cy='12' r='12' fill='#F4821F' />
      <path
        d='M12 16.5L11.95 16.425C11.6027 15.904 11.429 15.6435 11.1996 15.4549C10.9964 15.288 10.7624 15.1627 10.5108 15.0863C10.2266 15 9.91355 15 9.28741 15H8.6C8.03995 15 7.75992 15 7.54601 14.891C7.35785 14.7951 7.20487 14.6422 7.10899 14.454C7 14.2401 7 13.9601 7 13.4V9.1C7 8.53995 7 8.25992 7.10899 8.04601C7.20487 7.85785 7.35785 7.70487 7.54601 7.60899C7.75992 7.5 8.03995 7.5 8.6 7.5H8.8C9.9201 7.5 10.4802 7.5 10.908 7.71799C11.2843 7.90973 11.5903 8.21569 11.782 8.59202C12 9.01984 12 9.5799 12 10.7M12 16.5V10.7M12 16.5L12.05 16.425C12.3973 15.904 12.571 15.6435 12.8004 15.4549C13.0036 15.288 13.2376 15.1627 13.4892 15.0863C13.7734 15 14.0864 15 14.7126 15H15.4C15.9601 15 16.2401 15 16.454 14.891C16.6422 14.7951 16.7951 14.6422 16.891 14.454C17 14.2401 17 13.9601 17 13.4V9.1C17 8.53995 17 8.25992 16.891 8.04601C16.7951 7.85785 16.6422 7.70487 16.454 7.60899C16.2401 7.5 15.9601 7.5 15.4 7.5H15.2C14.0799 7.5 13.5198 7.5 13.092 7.71799C12.7157 7.90973 12.4097 8.21569 12.218 8.59202C12 9.01984 12 9.5799 12 10.7'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Open;
